import React, { Component } from "react";
import axios from "axios";
// import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	// faComment,
	// faTimesCircle,
	faCaretRight
} from "@fortawesome/free-solid-svg-icons";
import styles from "./Chat.scss";
// import classnames from "classnames";
var moment = require("moment");


export default class Chat extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			messages: [],
			message: "",
			session_id: null,
			intent: "None",
			context: {},
			customer_id: null,
			flag: null,
			button: null,
			start: moment().format("YYYY-MM-DD HH:mm:ss"),
			set: false,
			show: false
		};
	}

	componentDidMount = () => {
		const urlParams = new URLSearchParams(window.location.search);
    const hostURL = urlParams.get('host');
    const linkURL = `${hostURL}`
		// Set URL to host param, default to possiblemadehere.org
		this.setState({
			url: hostURL ? linkURL : "possiblemadehere.org"
		})


		this.initiateChatBot();

	};

	initiateChatBot = () => {
		axios.post("/api/chatBot", this.state).then(res => {
      // Set URL to host param, default to possiblemadehere.org
			if (!res.data.offline){
				res.data.context.skills["main skill"].user_defined.url = this.state.url ? this.state.url : "possiblemadehere.org";
			}
			let dataObj = {
				msg: res.data.offline
					? "Sorry! the chatbot is currently offline"
					: res.data.output.generic[0].text,
				from: "bot",
				intent: "None",
				button: null
			};
			if (!res.data.offline) {
				this.setState({
					messages: [...this.state.messages, dataObj],
					context: res.data.context.skills["main skill"].user_defined,
					session_id: res.data.output.session,
					customer_id:
						res.data.context.skills["main skill"].user_defined
							.customer_id
				});
			} else {
				this.setState({
					messages: [...this.state.messages, dataObj]
				});
			}
		});
	};

	componentDidUpdate() {
		this.scrollToBottom();
	}

	scrollToBottom = () => {
		const scrollHeight = this.messagesContainer.scrollHeight;
		const height = this.messagesContainer.clientHeight;
		const maxScrollTop = scrollHeight - height;
		this.messagesContainer.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
	};

	chatClick = (msg = "") => {
		this.setState({
			message: msg,
			context: {...this.state.context, button: null}
		}, () => this.chatbot(msg) );
	};

	chatbot = (data = "") => {
		this.setState({ message: "" });
		let dataObj = {
			msg: data,
			from: "user"
		};
		// eslint-disable-next-line
		let input = {
			input: {
				text: data
			}
		};
		this.setState({
			messages: [...this.state.messages, dataObj],
			button: null
		});
		axios
			.post("/api/chatBot", this.state)
			.then(res => {
				if (res.data.offline) {
					let dataObj = {
						msg:
							"Sorry! The chatbot is experiencing technical difficulties.",
						from: "bot",
						button: null
					};
					this.setState({
						messages: [...this.state.messages, dataObj],
						message: ""
					});
				} else {
					let dataObj = {
						msg: res.data.output.generic[0].text,
						from: "bot",
						intent:
							typeof res.data.output.intents[0] !== "undefined"
								? res.data.output.intents[0].intent
								: "None",
						button:
							typeof res.data.context.skills !== "undefined"
								? res.data.context.skills["main skill"]
										.user_defined.button
								: null
					};
          console.log("FRONT\n"+JSON.stringify(res.data, null, 4));
					this.setState({
						messages: [...this.state.messages, dataObj],
						message: "",
						context:
							res.data.context.skills["main skill"].user_defined,
						intent:
							typeof res.data.output.intents[0] !== "undefined"
								? res.data.output.intents[0].intent
								: "None",
						session_id: res.data.output.session,
						flag:
							typeof res.data.context.skills !== "undefined"
								? res.data.context.skills["main skill"]
										.user_defined.flag
								: null
					});
				}
			})
			.catch(error => {
				console.log(error);
			});
	};

	handleChange = event => {
		this.setState({ message: event.target.value });
	};

	createMarkup = msg => {
		return { __html: msg };
	};

	Messages = () => {
		return (
			<div
				ref={el => {
					this.messagesContainer = el;
				}}
				className="messages"
			>
				{this.state.messages.map(msg => (
					<div className="box">
						<div
							className={
								msg.from === "bot"
									? "bot-response"
									: "user-response"
							}
							style={
								msg.button != null
									? { backgroundColor: "white" }
									: { backgroundColor: "#a05770" }
							}
						>
              {msg.button === "hockey" && (
                <div>
                <div class="row">
                  <div class="bot-response">
                    Looks like you're asking about hockey, to see a list of hockey leagues and their websites click which type of league you're looking for.
                  </div>
                  </div>
                <div class="row">
                  <div className="btn-group-vertical" style={{width: "75%"}}>
                    <button
                      type="button"
                      className="btn msg-btn"
                      onClick={() =>
                        this.chatClick("Minor Hockey")
                      }
                    >
                      Minor Hockey
                    </button>
                    <button
                      type="button"
                      className="btn msg-btn"
                      onClick={() =>
                        this.chatClick("Junior/University Hockey")
                      }
                    >
                      Junior/University Hockey
                    </button>
                    <button
                      type="button"
                      className="btn msg-btn"
                      onClick={() =>
                        this.chatClick("Adult Hockey")
                      }
                    >
                    Adult Hockey
                    </button>
                  </div>
                </div>
                </div>
                )}
                {msg.button === "soccer" && (
                <div>
                <div class="row">
                  <p class="bot-response">
                    Looks like you're asking about soccer, to see a list of soccer leagues and their websites click which type of league you're looking for.
                  </p>
                  </div>
                <div class="row">
                  <div className="btn-group-vertical" style={{width: "75%"}}>
                    <button
                      type="button"
                      className="btn msg-btn"
                      onClick={() =>
                        this.chatClick("Youth Soccer")
                      }
                    >
                      Youth Soccer
                    </button>
                    <button
                      type="button"
                      className="btn msg-btn"
                      onClick={() =>
                        this.chatClick("University/College Soccer")
                      }
                    >
                      University/College Soccer
                    </button>
                    <button
                      type="button"
                      className="btn msg-btn"
                      onClick={() =>
                        this.chatClick("Adult Soccer")
                      }
                    >
                    Adult Soccer
                    </button>
                  </div>
                </div>
                </div>
                )}
							{msg.button === "age" && (
								<div>
                <div class="row">
									<div className="bot-response">
										So that I can personalize your
										experience here, what age range do you
										fall under?
									</div>
                  </div>
                  <div class="row" >
									<div className="btn-group-vertical" style={{width: "75%"}}>
										<button
											type="button"
											className="btn msg-btn"
											onClick={() =>
												this.chatClick("Under 25")
											}
										>
											Under 25
										</button>
										<button
											type="button"
											className="btn msg-btn"
											onClick={() =>
												this.chatClick("25 - 35")
											}
										>
											25 - 35
										</button>
										<button
											type="button"
											className="btn msg-btn"
											onClick={() =>
												this.chatClick("Over 35")
											}
										>
											Over 35
										</button>
										<button
											type="button"
											className="btn msg-btn"
											onClick={() =>
												this.chatClick("N/A")
											}
										>
											Skip
										</button>
									</div>
                  </div>
								</div>
							)}
							{msg.button === "sports" && (
								<div className="btn-group-vertical">
									<div className="bot-response">
										What sport would you like more
										information about?
									</div>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() => this.chatClick("Hockey")}
									>
										Hockey
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() => this.chatClick("Soccer")}
									>
										Soccer
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("Baseball")
										}
									>
										Baseball
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() => this.chatClick("Golf")}
									>
										Golf
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("Curling")
										}
									>
										Curling
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("Volleyball")
										}
									>
										Volleyball
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("Ultimate Frisbee")
										}
									>
										Ultimate Frisbee
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() => this.chatClick("Tennis")}
									>
										Tennis
									</button>
								</div>
							)}
							{msg.button === "weather" && (
								<div className="btn-group-vertical">
									<div className="bot-response">
										What type of forecast would you like to
										see?
									</div>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("Current weather")
										}
									>
										Current weather
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("Today's weather")
										}
									>
										Today's weather
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("7 day weather")
										}
									>
										7 day weather
									</button>
									<button
										type="button"
										className="btn msg-btn"
										onClick={() =>
											this.chatClick("Climate info")
										}
									>
										Climate info
									</button>
								</div>
							)}
							{(msg.button == null || msg.button === "other") && (
								<div
									dangerouslySetInnerHTML={this.createMarkup(
										msg.msg
									)}
								/>
							)}
						</div>
					</div>
				))}
				{this.state.messages.length > 0 &&
					this.state.messages[this.state.messages.length - 1].from ===
						"user" && (
						<div className="box">
							<div className="bot-response">...</div>
						</div>
					)}
			</div>
		);
	};
	render() {
		// const chatClass = classnames("chat-window", { open: this.state.open });
		// const bubbleClass = classnames(
		// 	"bubble",
		// 	this.state.show ? "show" : "hide"
		// );
		return (
			<div className={styles.Chat}>
				<div
					className="chat-btn"
					// onClick={() => {
					// 	// this.toggleOpen();
					// 	// this.setState({
					// 	// 	show: false
					// 	// });
					// 	if (!this.state.set && !this.state.customer_id)
					// 		this.initiateChatBot();
					// }}
				>
					{/*<FontAwesomeIcon icon={faComment} />
          <div className={bubbleClass}>
            <p>Hello, need any help?</p>
          </div>
        </div>
        <div className={chatClass}>
          {/*<div className="header">
            <h4>Chat</h4>
            <FontAwesomeIcon
              icon={faTimesCircle}
              size="2x"
              onClick={this.toggleOpen}
            />
          </div>*/}
					{this.Messages()}
					<div className="input" id="test">
						<input
							type="text"
							placeholder="Type your reply here..."
							id="message"
							name="message"
							value={this.state.message}
							className="form-control"
							onChange={this.handleChange}
							onKeyPress={event => {
								if (event.key === "Enter" && this.state.message.trim() !== '') {
									this.chatbot(this.state.message);
								}
							}}
						/>
						<FontAwesomeIcon
							icon={faCaretRight}
							size="2x"
							onClick={() => {
								this.chatbot(this.state.message);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/chat/Chat.js